import { capitalizeFirst } from '@zillow/home-details-formatters';
export function formatCity(value) {
  var capitalFirstWords = (value || '').split(' ').map(function (word) {
    return String(capitalizeFirst(word.toLowerCase()));
  });
  return capitalFirstWords.join(' ');
}
//# sourceMappingURL=addressUtils.js.map